import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
  Label,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  gAPI_Property_List_By_Group,
  API_Phone_Suite,
  API_Phone_Suite_Interation_Group,
  API_CONNECTWARE,
} from '../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../components/common/react-notifications';

let arr = [];
export default function PhoneSuiteIntegration({
  visible,
  toggle,
  id,
  LoadIntegrations,
}) {
  const [property, setProperty] = useState([]);
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Properties: [],
    SessionTimeoutInSeconds: 600,
    DefaultLanguage: 'en-US',
    domain: 'hotelmyma.nlv.uc',
    serviceProviderName: 'Myma.ai',
  });
  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setProperty([...res.data]);
      })
      .catch((err) => console.error(err));
  }, [id]);

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handleCheckChange = (e) => {
    if (e.target.checked) {
      setInputData({ ...inputData, Properties: [e.target.value] });
    }
    if (!e.target.checked) {
      setInputData({ ...inputData, Properties: [] });
    }
  };

  const handleSave = async () => {
    const finalData = {
      ...inputData,
      domain: 'hotelmyma.nlv.uc',
      serviceProviderName: 'Myma.ai',
    };
    AxiosAPI({
      method: 'get',
      url: `${API_CONNECTWARE}/check-domain?domain=${finalData?.domain}`,
    }).then((res) => {
      if (res.data.domain !== undefined && res.data.domain !== null) {
        AxiosAPI({
          method: 'post',
          url: API_Phone_Suite,
          data: finalData,
        }).then((res) => {
          let groupRequest = {
            groupId: getGroupID(),
            propertyId: finalData?.Properties[0],
            domain: finalData?.domain,
            creator: 'Dashboard',
          };
          groupRequest.integrationId = res.data.id;
          AxiosAPI({
            method: 'post',
            url: `${API_Phone_Suite_Interation_Group}`,
            data: groupRequest,
          }).then(() =>
            setTimeout(() => {
              LoadIntegrations();
              // window.location.reload();
            }, 300)
          );
        });
        LoadIntegrations();
        toggle();
      } else {
        NotificationManager.error(
          '',
          'Domain is not correct.',
          3000,
          null,
          null,
          'error'
        );
      }
    });
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>
                  {id === undefined ? 'Add' : 'Update'} Voice AI Integration
                </h6>
                <Separator className="mb-3" />
                <Form className="text-left">
                  <FormGroup className="mb-2">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Voice AI"
                      defaultValue={inputData.Name}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2" style={{ display: 'none' }}>
                    <Label>Service Provider Name</Label>
                    <Input
                      type="text"
                      name="serviceName"
                      onChange={(e) =>
                        setInputData({
                          ...inputData,
                          serviceProviderName: e.target.value,
                        })
                      }
                      placeholder="Service Provider Name"
                      defaultValue={inputData.serviceProviderName}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2" style={{ display: 'none' }}>
                    <Label>Domain Name</Label>
                    <Input
                      type="text"
                      name="domainName"
                      onChange={(e) =>
                        setInputData({ ...inputData, domain: e.target.value })
                      }
                      placeholder="Domain Name"
                      defaultValue={inputData.domain}
                    />
                  </FormGroup>
                  <FormGroup className="mt-3">
                    <div className="integration-property text-left">
                      {property.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="radio"
                            id={index}
                            label={p.name}
                            value={p.id}
                            name="property"
                            checked={
                              p.id === inputData.Properties[0] ? true : false
                            }
                            onChange={handleCheckChange}
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}
